import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GamesPage = lazy(() => import('../pages/games/page'));
const GameDetailPage = lazy(() => import('../pages/game-detail/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/games',
    element: <GamesPage />,
  },
  {
    path: '/game/:slug',
    element: <GameDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;